import moduleConfig from './module-config';
import netsPasswordReset from './nets-password-reset';

export default angular
  .module('app.passwordReset', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsPasswordReset', netsPasswordReset);
